// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1vpp9","label":"SetPasswdForm_label__jKs0X"};